(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Tour Dates Section Functionality
    /*****************************************************/
    if ($(".tour-dates-section").length) {
      console.log("tour-filters.js initiated");

      const tourFilters = {
        init: function () {
          this.bindEvents();
          this.currentFilters = {
            month: "",
            country: "",
          };
        },

        bindEvents: function () {
          const self = this;

          // Custom select functionality
          $(".custom-select").each(function () {
            const $select = $(this);
            const $selected = $select.find(".select-selected");
            const $items = $select.find(".select-items");
            const filterType = $select.data("filter");

            // Click on select to open/close
            $selected.on("click", function (e) {
              e.stopPropagation();

              // Close all other selects
              $(".select-items").addClass("select-hide");
              $(".custom-select").removeClass("select-arrow-active");

              // Toggle current select
              $items.toggleClass("select-hide");
              $select.toggleClass("select-arrow-active");
            });

            // Click on options
            $select.find(".select-option").on("click", function (e) {
              e.stopPropagation();
              const value = $(this).data("value");
              const text = $(this).text();

              // Update selected text
              $selected.text(text);

              // Update filter value
              self.currentFilters[filterType] = value;

              // Close dropdown
              $items.addClass("select-hide");
              $select.removeClass("select-arrow-active");

              // Apply filters
              self.filterTourDates();
            });
          });

          // Close dropdowns when clicking outside
          $(document).on("click", function (e) {
            if (!$(e.target).closest(".custom-select").length) {
              $(".select-items").addClass("select-hide");
              $(".custom-select").removeClass("select-arrow-active");
            }
          });
        },

        filterTourDates: function () {
          const self = this;
          const tourCards = $(".tour-date-card");
          let visibleCount = 0;

          tourCards.each(function () {
            const $card = $(this);
            const cardMonth = $card.data("month");
            const cardCountry = $card.data("country");

            let shouldShow = true;

            // Check month filter
            if (self.currentFilters.month && cardMonth !== self.currentFilters.month) {
              shouldShow = false;
            }

            // Check country filter
            if (self.currentFilters.country && cardCountry !== self.currentFilters.country) {
              shouldShow = false;
            }

            // Show/hide card with smooth transition
            if (shouldShow) {
              $card.fadeIn(300);
              visibleCount++;
            } else {
              $card.fadeOut(300);
            }
          });

          // Update filter labels to show count
          self.updateFilterLabels(visibleCount);
        },

        updateFilterLabels: function (visibleCount) {
          const totalCount = $(".tour-date-card").length;
          const filterWrap = $(".filter-wrap");

          // Remove existing count display and no results message
          $(".filter-count").remove();
          $(".no-results-message").remove();

          // Add count display
          if (visibleCount !== totalCount) {
            filterWrap.append(`<div class="filter-count lead">Showing ${visibleCount} of ${totalCount}</div>`);
          }

          // Add no results message if no dates are visible
          if (visibleCount === 0) {
            $(".tour-dates-wrap").append('<p class="h2 text--center no-results-message">No shows with those options</p>');
          }
        },

        resetFilters: function () {
          $(".custom-select").each(function () {
            const $select = $(this);
            const filterType = $select.data("filter");
            const defaultText = filterType === "month" ? "Month" : "Country";

            $select.find(".select-selected").text(defaultText);
          });

          this.currentFilters = {
            month: "",
            country: "",
          };
          this.filterTourDates();
        },
      };

      // Initialize tour filters
      tourFilters.init();
    }
  });
})(jQuery);
